import React from 'react';
import type { GhlBookingRecord } from '@/lib/ghl-booking';

const FIELDS: { key: keyof GhlBookingRecord; label: string }[] = [
  { key: 'timezone', label: 'Timezone' },
  { key: 'selectedTimezone', label: 'Selected timezone' },
  { key: 'calendarName', label: 'Calendar name' },
  { key: 'source', label: 'Source' },
  { key: 'selectedSlot', label: 'Selected slot' },
  { key: 'pageUrl', label: 'Page URL' },
];

export function ProspectGhlBookingCard({ booking }: { booking: GhlBookingRecord }) {
  return (
    <div className="pt-2 border-t border-border space-y-3" data-testid="prospect-ghl-booking">
      <div className="text-xs font-semibold text-muted-foreground uppercase tracking-wider">
        GHL booking
      </div>
      {FIELDS.map(({ key, label }) => {
        const value = booking[key];
        return (
          <div key={key} data-testid={`ghl-booking-${key}`}>
            <div className="text-xs font-semibold text-muted-foreground mb-0.5">{label}</div>
            {key === 'pageUrl' && typeof value === 'string' && value ? (
              <a
                href={value}
                className="text-foreground font-medium underline break-all"
                rel="noreferrer"
              >
                {value}
              </a>
            ) : (
              <div className="text-foreground font-medium">{value || '—'}</div>
            )}
          </div>
        );
      })}
    </div>
  );
}
